/// International Code of Signals flag palette. The exact reference
/// hues vary by manufacturer; these are the closest sRGB
/// approximations that read correctly on common phone / laptop
/// screens.

export const ICS = {
  blue: "#003c9b",
  red: "#cb1f1f",
  yellow: "#f7d100",
  black: "#0a0a0a",
  white: "#ffffff",
} as const;

export type IcsColor = keyof typeof ICS;
